// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import _ from "lodash";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------
/** withUrl */
const withUrl = (checkThis, data) => {
  const { websiteUrl, nakedWebsiteUrl } = data;
  let returnString = "";

  if (!_.startsWith(checkThis, "http")) {
    if (_.startsWith(checkThis, "/")) {
      returnString = `${nakedWebsiteUrl}${checkThis}`;
    } else {
      returnString = `${websiteUrl}${checkThis}`;
    }
  }

  return returnString;
};

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default withUrl;



// WEBPACK FOOTER //
// ./src/helpers/withUrl.js